import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, ChevronRight } from 'lucide-react';
import { locations } from '../../data/locations';
export function LocationsPreview() {
  return <section className="relative py-24 overflow-hidden" data-id="element-297">
      {/* Background Map Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-298">
        <img src="https://cdn.magicpatterns.com/uploads/qyhDhLHoGw6ES81LFhTk6u/image.png" alt="Michigan Map" className="w-full h-full object-cover" data-id="element-299" />
        {/* White overlay for readability */}
        <div className="absolute inset-0 bg-white/75" data-id="element-300"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-301">
        <div className="text-center mb-12" data-id="element-302">
          <div className="inline-flex items-center justify-center p-3 bg-slate-100 rounded-full mb-8" data-id="element-303">
            <MapPin className="h-6 w-6 text-[#dc2626]" data-id="element-304" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2332] mb-6" data-id="element-305">
            Training Available at 6 Locations Across Michigan
          </h2>

          <p className="text-lg text-slate-600 mb-4 max-w-2xl mx-auto" data-id="element-306">
            We serve multiple communities throughout Michigan, making quality
            martial arts training accessible and convenient for families across
            the region.
          </p>

          <p className="text-base text-slate-500 max-w-2xl mx-auto" data-id="element-307">
            Each location maintains consistent training standards and
            curriculum, so you can trust the same quality instruction no matter
            where you train.
          </p>
        </div>

        {/* Location Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8" data-id="element-308">
          {locations.map(location => <div key={location.id} className="bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow p-6" data-id="element-309">
              <div className="flex items-start mb-4" data-id="element-310">
                <MapPin className="h-5 w-5 text-[#dc2626] mr-2 flex-shrink-0 mt-1" data-id="element-311" />
                <div data-id="element-312">
                  <h3 className="text-xl font-bold text-[#1a2332] mb-1" data-id="element-313">
                    {location.name}
                  </h3>
                  <p className="text-sm text-slate-600" data-id="element-314">{location.city}</p>
                </div>
              </div>

              <p className="text-sm text-slate-600 mb-4" data-id="element-315">{location.address}</p>

              <ul className="space-y-2 mb-6" data-id="element-316">
                {location.highlights.map((highlight, index) => <li key={index} className="text-sm text-slate-700 flex items-center" data-id="element-317">
                    <span className="w-1.5 h-1.5 bg-[#dc2626] rounded-full mr-2" data-id="element-318"></span>
                    {highlight}
                  </li>)}
              </ul>

              <Link to={`/locations/${location.id}`} className="inline-flex items-center text-sm font-medium text-[#dc2626] hover:text-[#b91c1c] transition-colors group" data-id="element-319">
                View Location
                <ChevronRight className="ml-1 h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-320" />
              </Link>
            </div>)}
        </div>

        {/* Optional: View All Locations Link */}
        <div className="text-center" data-id="element-321">
          <Link to="/locations" className="text-sm font-medium text-slate-600 hover:text-[#1a2332] transition-colors" data-id="element-322">
            View All Locations →
          </Link>
        </div>
      </div>
    </section>;
}